<template>
  <div class="styj">
    <Head v-bind:headTxt="headTxt"></Head>

    <YangBen v-bind:YangBenBox="YangBenBox"></YangBen>

    <ShiJi v-bind:shiJiBox="shiJiBox"></ShiJi>

    <RightBox v-bind:rightBox="rightBox"></RightBox>

    <div class="map_box">
      <Map v-bind:mapBut="mapBut"></Map>
    </div>

    <div class="l_box">
      <div class="l_box_1">
        <div class="bgc box_1_l">
          <div class="box_1_l_txt">
            <ul>
              <li>省级认定：{{ styjList.a_Village_province }}</li>
              <li>地方认定：{{ styjList.a_Village_dlace }}</li>
              <li>平均聚居时长：{{ styjList.a_Village_dwell }}</li>
            </ul>
          </div>
          <div class="chart1" id="l_chart_chuantongcunluo"></div>
        </div>
        <div class="bgc box_1_r">
          <div class="chart2" id="l_chart_xiangcun"></div>
        </div>
      </div>
      <div class="bgc l_box_2">
        <div class="l_box_2_l">
          <div class="l_box_2_zs">
            <p style="margin-top: 17%"></p>
            <span class="txtc">{{
              styjList.a_Scenic_province +
              styjList.a_Scenic_nation +
              styjList.a_Scenic_dwell
            }}</span>
            <p>国家认定：{{ styjList.a_Scenic_dwell }}</p>
            <p style="margin-top: 2%">
              省级认定：{{
                styjList.a_Scenic_province
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地方认定：{{
                styjList.a_Scenic_nation
              }}
            </p>
            <p></p>
          </div>
          <div class="chart3" id="l_chart_jingqu"></div>
        </div>
        <div class="l_box_2_r">
          <template>
            <el-table
              :data="tableData"
              height="100%"
              table-layout="auto"
              style="width: 90%"
            >
              <el-table-column label="旅  游  景  区">
                <template slot-scope="scope">
                  <!--渲染对应表格里面的内容-->
                  {{ scope.row }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div class="bgc l_box_3">
        <div v-show="scenic_img.length > 0">
          <el-carousel height="100%" indicator-position="none" type="card">
            <el-carousel-item v-for="(item, index) in scenic_img" :key="index">
              <el-image
                style="width: 100%; height: 90%; margin-top: 3%"
                :src="item"
                fit="cover"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
          <!-- <el-carousel :loop="false"
                       :autoplay="false"
                       type="card"
                       height="100%">
            <el-carousel-item class="el-car-item"
                              v-for="(list, index) in scenic_img"
                              :key="index">
              <img v-for="(item,index2) in list"
                    style="width:50%; height:100%;"
                   :key="index2"
                   class="top-img"
                   :src="item"/>
            </el-carousel-item>
          </el-carousel> -->
        </div>
        <div v-show="scenic_img.length == 0">
          <span class="noTxt" style="line-height: 25vh; margin-left: 45%"
            >暂无调研图片</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "@/components/Head.vue";
import YangBen from "@/components/YangBen.vue";
import RightBox from "@/components/RightBox.vue";
import ShiJi from "@/components/ShiJi.vue";
import Map from "@/components/Map.vue";
import bus from "../utils/bus.js";

export default {
  components: {
    Head,
    YangBen,
    RightBox,
    ShiJi,
    Map,
  },
  data() {
    return {
      YangBenBox: {
        xian: "31",
        xiang: "16",
        cun: "130",
      },
      shiJiBox: {
        shiJiTitle: "生态宜居大事记",
        diDian: "湖南省",
        shiJiList: [
          "勾蓝瑶寨农村环境整治整体推进综合治理项目，自2018年6月开工建设以来，共投资60余万元，对全村进行集中整治。建设了农村饮用水项目、生活污水治理项目、生活垃圾收集系统、农村改厕改水和农村“五清五化”治理等。",
          "2022年8月，青年水库，水域面积750多亩，总库容600余万立方米，主要用于农业灌溉、城市生态补水、防洪排涝、景观用水等，提升青年水库水质，加强周边生态环境保护尤为重要。",
        ],
      },
      rightBox: {
        boxTitle: "湖南民族地区乡村生态宜居简介",
        boxText:
          "湖南地形以山地丘陵为主，大陆性亚热带季风湿润气候。党的十八大以来,湖南深入践行习近平生态文明思想,牢记“守护好一江碧水”的殷殷嘱托,以前所未有的力度推进生态文明建设,全省生态环境发生了历史性、转折性、全局性变化。",
        images: [],
      },
      headTxt: "生态宜居数据仓",
      mapBut: "湖南山势地图>>>",

      scenic_img: [],

      tableData: [
        {
          date: "杨家界景区",
        },
        {
          date: "清风峡",
        },
        {
          date: "五号山谷民宿",
        },
        {
          date: "回家的孩子民宿",
        },
      ],

      // 传统古村落
      cunLuoChar: null,

      // 已经开发景区
      jinQuChar: null,

      // 美丽乡村
      meiCunChar: null,

      city_id: "0",
      styjList: {},
    };
  },
  mounted() {
    this.getDate();

    bus.$on("mapBus", (date) => {
      console.log(date, "mapBushhhhhh");
      this.getDate(date);
    });
  },
  methods: {
    getDate(date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = JSON.parse(localStorage.getItem("date"));
      date.forEach((item, index) => {
        if (item.region == newDate) {
          this.styjList = item;
        }
      });
      
      console.log(this.styjList, "数据");
      this.rightBox.images = [];
      const introList = this.styjList.ecology_intro.split("#");
      this.rightBox.boxText = introList[0];
      for (let i = 1; i < introList.length; i++) {
        this.rightBox.images.push(introList[i]);
      }
      console.log(this.rightBox, "数据处理后");

      // 传统古村落
      this.cunLuoEcharts();
      // 已经开发景区
      this.jinQuEcharts();
      // 美丽乡村
      this.meiCunEcharts();

      // 处理图片
      this.scenic_img = this.styjList.alist.map((item) => {
        return item.scenic_img;
      });
      for (var i = this.scenic_img.length - 1; i >= 0; i--) {
        if (this.scenic_img[i] == "" || this.scenic_img[i] == null) {
          this.scenic_img.splice(i, 1);
        }
      }
      if (this.scenic_img.length > 0) {
        this.scenic_img = this.scenic_img.join("、");
        this.scenic_img = this.scenic_img.split("、");
      }
      console.log(this.scenic_img, "kkkkkkkkkkkkk");

      // 处理旅游景区数据
      this.tableData = this.styjList.alist.map((item) => {
        return item.scenic_name;
      });
      this.tableData = this.tableData.join("、");
      this.tableData = this.tableData.split("、");
      for (var i = this.tableData.length - 1; i >= 0; i--) {
        if (
          this.tableData[i] == "" ||
          this.tableData[i] == null ||
          this.tableData[i] == "无"
        ) {
          this.tableData.splice(i, 1);
        }
      }
      console.log(this.tableData);

      // 处理大事记数据
      this.shiJiBox.shiJiList = this.styjList.alist.map((item) => {
        return (
          item.event_date +
          "  |  " +
          item.event_influence +
          "  |  " +
          item.event_name
        );
      });
      console.log(this.shiJiBox.shiJiList, "hhhhhhhh");
      for (var i = this.shiJiBox.shiJiList.length - 1; i >= 0; i--) {
        if (
          this.shiJiBox.shiJiList[i] == "  |    |  " ||
          this.shiJiBox.shiJiList[i] == "null  |  null  |  null" ||
          this.shiJiBox.shiJiList[i] == "无  |  无  |  无"
        ) {
          this.shiJiBox.shiJiList.splice(i, 1);
        }
      }
      console.log(this.shiJiBox.shiJiList);
    },

    // 传统古村落
    cunLuoEcharts() {
      this.cunLuoChar = this.$echarts.init(
        document.getElementById("l_chart_chuantongcunluo")
      );
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.cunLuoChar.resize();
      });
      var optoin = {
        title: {
          text: "传统古村落",
          left: "3%",
          top: "2%",
          textStyle: {
            color: "#333",
            fontSize: this.$fontSize.fontSize(0.2),
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: 'vertical',
        //   width: '50%',
        //   top: "30%",//图例组件离容器上侧的距离
        //   left: "30%",//图例组件离容器左侧的距离
        //   textStyle: {
        //     color: "#333"
        //   }
        // },
        series: [
          {
            type: "pie",
            avoidLabelOverlap: false,
            center: ["75%", "45%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: "#666",
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value + "\n" + params.name;
                  } else {
                    return "";
                  }
                },
                position: "inner",
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                  },
                  b: {
                    //name 文字样式
                    fontSize: 12,
                    lineHeight: 15,
                    // color: '#666',
                  },
                  c: {
                    //value 文字样式
                    fontSize: 12,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center",
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.styjList.a_Village_nation,
                itemStyle: {
                  color: "#009999",
                },
                name: "国家认定",
              },
              {
                value: this.styjList.a_Village_province,
                itemStyle: {
                  color: "#66CCCC",
                },
                name: "省级认定",
              },
              {
                value: this.styjList.a_Village_dlace,
                itemStyle: {
                  color: "#CCFFFF",
                },
                name: "地方认定",
              },
            ],
          },
        ],
      };
      this.cunLuoChar.setOption(optoin);
    },

    // 已经开发景区
    jinQuEcharts() {
      this.jinQuChar = this.$echarts.init(
        document.getElementById("l_chart_jingqu")
      );
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.jinQuChar.resize();
      });
      var optoin = {
        title: {
          text: "已经开发景区",
          left: "3%",
          top: "2%",
          textStyle: {
            color: "#333",
            fontSize: this.$fontSize.fontSize(0.2),
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: 'vertical',
        //   width: '50%',
        //   top: "30%",//图例组件离容器上侧的距离
        //   left: "30%",//图例组件离容器左侧的距离
        //   textStyle: {
        //     color: "#333"
        //   }
        // },
        series: [
          {
            type: "pie",
            avoidLabelOverlap: false,
            radius: "90%",
            center: ["75%", "50%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: "#666",
            },
            // center: ['50%', '50%'], // 这个属性可以调整图像的位置，左面所示为中心
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value + "\n" + params.name;
                  } else {
                    return "";
                  }
                },
                position: "inner",
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                  },
                  b: {
                    //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                  },
                  c: {
                    //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center",
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.styjList.a_Scenic_dwell,
                itemStyle: {
                  color: "#009999",
                },
                name: "国家认定",
              },
              {
                value: this.styjList.a_Scenic_province,
                itemStyle: {
                  color: "#66CCCC",
                },
                name: "省级认定",
              },
              {
                value: this.styjList.a_Scenic_nation,
                itemStyle: {
                  color: "#CCFFFF",
                },
                name: "地方认定",
              },
            ],
          },
        ],
      };
      this.jinQuChar.setOption(optoin);
    },

    // 美丽乡村
    meiCunEcharts() {
      this.meiCunChar = this.$echarts.init(
        document.getElementById("l_chart_xiangcun")
      );
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.meiCunChar.resize();
      });
      var optoin = {
        title: {
          text: "美丽乡村",
          left: "3%",
          top: "2%",
          textStyle: {
            color: "#333",
            fontSize: this.$fontSize.fontSize(0.2),
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        xAxis: {
          axisLabel: {
            show: true,
            interval: 0, //使x轴上的文字显示完全,
            fontSize: this.$fontSize.fontSize(0.1),
            color: "#000",
            fontWeight: 900,
          },
        },
        yAxis: {
          data: ["国家认定", "省级认定", "地方认定", "总计"],
          axisLabel: {
            show: true,
            interval: 0, //使x轴上的文字显示完全,
            color: "#000",
            fontWeight: 900,
          },
        },
        grid: {
          top: "30%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            type: "bar",
            label: {
              //柱体上显示数值
              show: true, //开启显示
              position: "right",
              formatter: "{c}",
            },
            data: [
              {
                value: this.styjList.a_Country_nation,
                itemStyle: {
                  color: "#5B8FF9",
                },
              },
              {
                value: this.styjList.a_Country_province,
                itemStyle: {
                  color: "#E8684A",
                },
              },
              {
                value: this.styjList.a_Country_dlace,
                itemStyle: {
                  color: "#9270CA",
                },
              },
              {
                value:
                  this.styjList.a_Country_dlace +
                  this.styjList.a_Country_province +
                  this.styjList.a_Country_nation,
                itemStyle: {
                  color: "#269A99",
                },
              },
            ],
          },
        ],
      };
      this.meiCunChar.setOption(optoin);
    },

    imgData() {
      let newDataList = [];
      let current = 0;
      if (this.dataList && this.dataList.length > 0) {
        for (let i = 0; i <= this.dataList.length - 1; i++) {
          if (i % 4 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([this.dataList[i]]);
            } else {
              newDataList[current].push(this.dataList[i]);
            }
          } else {
            current++;
            newDataList.push([this.dataList[i]]);
          }
        }
      }
      this.dataList = [...newDataList];
    },
  },
};
</script>

<style lang="less" scoped>
.map_box {
  position: absolute;
  top: 7vh;
  left: 35%;
  width: 39%;
  height: 87vh;
}

.l_box {
  position: absolute;
  top: 16vh;
  left: 0;
  width: 34%;
  height: 58vh;
  margin: 1vh;

  .l_box_1 {
    display: flex;
    height: 18vh;

    .box_1_l {
      flex: 1;
      position: relative;

      .box_1_l_txt {
        position: absolute;
        top: 20%;
        left: 5%;
        font-size: calc(100vw * 16 / 1920);

        li {
          padding: 1vh 0;
        }
      }

      .chart1 {
        width: 100%;
        height: 100%;
      }
    }

    .box_1_r {
      flex: 1;
      margin-left: 1vh;

      .chart2 {
        width: 100%;
        height: 100%;
      }
    }
  }

  .l_box_2 {
    display: flex;
    height: 20vh;
    margin-top: 1vh;

    .l_box_2_l {
      position: relative;
      flex: 3;

      .l_box_2_zs {
        position: absolute;
        top: -5%;
        left: 5%;
        // text-align: center;

        span {
          font-size: calc(100vw * 80 / 1920);
          font-weight: 800;
        }
      }

      .chart3 {
        width: 100%;
        height: 100%;
      }
    }

    .l_box_2_r {
      flex: 2;
      margin: 1%;
      // background-color: #fff;

      /deep/ .el-table {
        margin: auto;
        padding: 0;
      }
      /deep/ .el-table tr,
      .el-table {
        background-color: rgba(255, 255, 255, 0);
      }

      /deep/ .el-table th.el-table__cell {
        background-color: rgba(255, 255, 255, 0);
        color: #ffde94;
      }

      /deep/ .cell {
        font-weight: 900;
      }

      /deep/ .el-table__cell {
        padding: 1vh 0;
        text-align: center;
      }

      // ----------修改elementui表格的默认样式-----------
      /deep/ .el-table__body-wrapper {
        &::-webkit-scrollbar {
          // 整个滚动条
          width: 0; // 纵向滚动条的宽度
          background: rgba(213, 215, 220, 0.3);
          border: none;
        }
        &::-webkit-scrollbar-track {
          // 滚动条轨道
          border: none;
        }
      }

      // --------------------隐藏table gutter列和内容区右侧的空白 start
      /deep/ .el-table th.gutter {
        display: none;
        width: 0;
      }
      .el-table colgroup col[name="gutter"] {
        display: none;
        width: 0;
      }

      /deep/ .el-table__body {
        width: 100% !important;
      }

      // --------------------隐藏table gutter列和内容区右侧的空白 end
    }
  }

  .l_box_3 {
    margin-top: 1vh;

    div {
      // width: 100%;
      height: 25vh;

      /deep/ .el-carousel__mask {
        background-color: rgba(255, 255, 255, 0);
      }
    }
  }
}
</style>